import services from './../../services/service'; // Service Class
import MainHeader from './../MainHeader/index.vue'; // Main Header
import MainFooter from './../MainFooter/index.vue'; // Main Footer
let service = new services();

export default {
    name: 'Register',
    data () {
        return {
            users: {},
            user: {},
            states: {},
            cities: {},
            disable_btn: false,
            data_error_message:"",
            disable_btn:false,
            action_loading:false,
        }
    },
    components: {
        'component-header': MainHeader,
        'component-footer': MainFooter
     },
    methods: {
        reset() {
            localStorage.removeItem("sp_user");
            localStorage.removeItem("sp_token");
            localStorage.removeItem("sp_token_key");
            localStorage.removeItem("sp_#_sellpoint");
        },
        activate_processing(){
            this.disable_btn = true;
            this.action_loading = true;
        },

        deactivate_processing(){
            this.disable_btn = false;
            this.action_loading = false;
        },
        login(){
            this.activate_processing();
            this.data_error_message = "";
            var credentials = {
                user_email: this.user.email,
                user_password: this.user.password
            }

            let navi = this.$router;
            if(credentials.user_email != null && credentials.user_password != null) {
                service.loginUser(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        localStorage.setItem("sp_user", data.user_name); 
                        localStorage.setItem("sp_token", data.user_session_key); //store session key here linked to session well @server
                        localStorage.setItem("sp_token_key", data.user_token_key); 
                        navi.push('/timeline');
                    }else{
                        // toastr.warning("invalid login credentials", 'Warning!'); 
                        this.data_error_message = "invalid login credentials";
                        // this.disable_btn = false;
                        this.deactivate_processing();
                    }
                }).catch((err) => {
                  //  console.log(err)
                    // toastr.warning("invalid login credentials", 'Warning!'); 
                    this.data_error_message = "Sorry, could not process request";
                    // this.disable_btn = false;
                    this.deactivate_processing();
                })
                    
            }else {
                // toastr.error('Kindly fill all fields', 'Warning!');
                this.data_error_message = "Kindly fill all fields";
                this.disable_btn = false;
            }
        }
    },
    created: function(){
       this.reset();
    }
}


// WEBPACK FOOTER //
// ./src/pages/Login/script.js